import { useEffect } from 'react'

export default function useAntiFocus({ onBlur, onFocus, onHidden, onVisible } = {}) {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // console.warn('Tab tidak aktif (visibilitychange)')
        onHidden?.()
      } else {
        // console.log('Tab aktif kembali (visibilitychange)')
        onVisible?.()
      }
    }

    const handleBlur = () => {
      //   console.warn('Browser kehilangan fokus (blur event)')
      onBlur?.()
    }

    const handleFocus = () => {
      //   console.log('Browser kembali fokus (focus event)')
      onFocus?.()
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('blur', handleBlur)
    window.addEventListener('focus', handleFocus)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('blur', handleBlur)
      window.removeEventListener('focus', handleFocus)
    }
  }, [onBlur, onFocus, onHidden, onVisible])
}
